const projectList = document.querySelector('.product-list__grid');
const filterLinks = document.querySelectorAll('.filter-links__item');
const yearSlider = document.querySelectorAll('.year-filter__init');
let dataPage = new URLSearchParams(window.location.search).get('data-page') || 1;
let period = new URLSearchParams(window.location.search).get('period') || 'all';
let searchStr = new URLSearchParams(window.location.search).get('search-term') || '';
let yearPeriod = new URLSearchParams(window.location.search).get('year-period') || '';
let yearFrom = 0;
let yearTo = 1;
let yearChanged = false;
const sendReqForObjects = (isotope) => {
  const loader = document.querySelector('.more-loader');
  const button = document.querySelector('.product-list__footer .btn');
  loader.style.display = 'block';
  button.style.display = 'none';
  dataPage = parseInt(dataPage, 10) + 1;
  const dataPagePara = dataPage !== 1 ? `&data-page=${dataPage}` : '';
  const searchStrPara = searchStr !== '' ? `&search-term=${searchStr}` : '';
  const yearPeriodPara = yearPeriod !== '' ? `&year-period=${yearPeriod}` : '';
  window.history.replaceState(null, null, `/?period=${period}${yearPeriodPara}${searchStrPara}${dataPagePara}`);
  axios
    .get(localData.siteURL, {
      params: {
        action: 'getNewObjects',
        id: localData.id,
        lang: localData.lang,
        'data-page': new URLSearchParams(window.location.search).get('data-page') || 1,
        period: new URLSearchParams(window.location.search).get('period') || 'all',
        'search-term': new URLSearchParams(window.location.search).get('search-term') || '',
        'year-period' : new URLSearchParams(window.location.search).get('year-period') || '',
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        const items = response.data.data.message;
        const itemsArray = items.split('*|NEW_ITEM|*');
        const container = document.querySelector('.product-list__grid');
        itemsArray.forEach((item) => {
          if (item !== '') {
            const gridItem = document.createElement('div');
            gridItem.classList.add('product-list__grid-item');
            gridItem.innerHTML = item;
            container.appendChild(gridItem);
            isotope.appended(gridItem);
          }
        });
        const imgs = document.querySelectorAll('.product-list__grid img');
        const len = imgs.length;
        let counter = 0;
        const incrementCounter = () => {
          counter += 1;
          if (counter === len) {
            isotope.layout();
          }
        };
        imgs.forEach((img) => {
          if (img.complete) {
            incrementCounter();
          } else {
            img.addEventListener('load', incrementCounter, false);
          }
        });
        document.querySelector('.product-list__footer').classList.toggle('hide', !response.data.data.has_next);
        document.querySelector('.no-results-text').classList.toggle('hide', response.data.data.has);
        loader.style.display = 'none';
        button.style.display = 'inline-flex';
      } else {
        console.error('error fetching new objects');
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

const showYearsFilter = (buttonSelect) => {
  if (!buttonSelect){
    // eslint-disable-next-line no-param-reassign
    buttonSelect = document.querySelector('.filter-links__item.is-active');
  }
  if(buttonSelect) {
    const parentElem = buttonSelect.closest('.product-list');
    const filterValues = buttonSelect.getAttribute('data-range');
    if (filterValues) {
      parentElem.classList.toggle('open-year-filter', buttonSelect.classList.contains('is-active'));
      const filterValuesArray = filterValues.split(',');
      yearFrom = 0;
      yearTo = filterValuesArray.length;
      const yearRangeSlider = $('.year-filter__init').data('ionRangeSlider');
      yearRangeSlider.update({
        values: filterValuesArray,
        from: yearFrom,
        to: yearTo,
      });
    } else {
      parentElem.classList.remove('open-year-filter');
    }
  }
};

const isotopeInit = () => {
  // ------
  // Init isotope ⤵
  // ------
  const productGrid = document.querySelector('.product-list__grid');

  // Initialize Isotope
  const isotope = new Isotope(productGrid, {
    itemSelector: '.product-list__grid-item',
    percentPosition: true,
    masonry: {
      columnWidth: '.grid-sizer',
    },
  });

  imagesLoaded(productGrid, () => isotope.layout());

  attachEvent('.product-list__footer .btn', 'click', (e) => {
    e.preventDefault();
    // create new item elements
    sendReqForObjects(isotope);
  });

  // ------
  // Year Slider ⤵
  // ------
  if (yearSlider.length > 0) {
    $('.year-filter__init').ionRangeSlider({
      type: 'double',
      grid: true,
      prettify_enabled: false,
      hide_min_max: true,
      hide_from_to: true,
      onChange (data) {
        if (data.to - data.from < 1) {
          const yearRangeSlider = $('.year-filter__init').data('ionRangeSlider');
          yearRangeSlider.update({
            from: yearFrom,
            to: yearTo,
          });
        } else {
          if(yearTo !== data.to) {
            yearChanged = true;
            yearTo = data.to;
          }
          if(yearFrom !== data.from) {
            yearChanged = true;
            yearFrom = data.from;
          }
        }
      },
      onFinish (data) {
        if (yearChanged) {
          isotope.remove(isotope.getItemElements());
          isotope.layout();
          yearPeriod = `${data.from}-${data.to}`;
          dataPage = 0;
          sendReqForObjects(isotope);
        }
        yearChanged =false;
      }
    });
    showYearsFilter();
    const removeFilterActiveClass = () => {
      filterLinks.forEach((link) => {
        link.classList.remove('is-active');
      });
    };

    // ------
    // Click on category ⤵
    // http://ionden.com/a/plugins/ion.rangeSlider/api.html
    // ------
    attachEvent('.filter-links__item', 'click', (ev) => {
      const parentElem = ev.target.closest('.product-list');
      isotope.remove(isotope.getItemElements());
      isotope.layout();
      dataPage = 0;
      if (ev.target.classList.contains('is-active')) {
        period = 'all';
        removeFilterActiveClass();
      } else {
        period = ev.target.dataset.value;
        removeFilterActiveClass();
        ev.target.classList.add('is-active');
      }
      yearPeriod = '';
      sendReqForObjects(isotope);
      // Update range slider
      showYearsFilter(ev.target);
    });
  }
  const filterSearchComponent = document.querySelector('.filter-search');
  const filterSearch = filterSearchComponent.querySelectorAll('.filter-search__input');

  if (filterSearchComponent){
    filterSearch.forEach((item) => {
      const searchInput = item.querySelector('.filter-search__input-field');
      if (searchStr) {
        searchInput.value = searchStr;
      }

      const searchForNewItems = () => {
        isotope.remove(isotope.getItemElements());
        isotope.layout();
        searchStr = searchInput.value;
        dataPage = 0;
        sendReqForObjects(isotope);
      };
      searchInput.addEventListener('keyup', debounce(searchForNewItems, 500));

      attachEvent('.filter-search__dropdown-option', 'click', (e) => {
        e.preventDefault();
        searchInput.value = e.target.getAttribute("data-value");
        filterSearchComponent.classList.remove('is-active');
        searchForNewItems();
      });

    });
  }
};

// ------
// Load isotope ⤵
// ------
if (projectList) {
  window.addEventListener('load', () => isotopeInit());
}
